export interface ApiE164CountryCode {
  Code: string;
  Country: string;
}

export interface E164CountryCode {
  code: string;
  country: string;
}

export function ApiE164CountryCodeToE164CountryCode(
  apiE164CountryCode: ApiE164CountryCode
): E164CountryCode {
  return {
    code: apiE164CountryCode.Code,
    country: apiE164CountryCode.Country
  };
}
